import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const DailyMotion: FC<IconSvgProps> = ({ color, clss, width = 128, height = 128 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 128 128" className={clss}>
            <g>
                <rect clipRule="evenodd" fill="none" fillRule="evenodd" />
                <path
                    clipRule="evenodd"
                    d="M75.086,60.339    c-9.352,0-16.585,7.607-16.585,16.585c0,9.352,7.232,16.46,17.333,16.46c8.479,0,15.587-6.983,15.587-16.211    C91.421,67.571,84.313,60.339,75.086,60.339z M110.375,110.841H91.296v-7.482c-5.861,5.736-11.846,7.856-19.827,7.856    c-8.105,0-15.088-2.619-20.949-7.856c-7.731-6.858-11.722-15.837-11.722-26.311c0-9.602,3.741-18.206,10.724-24.94    c6.235-6.11,13.842-9.228,22.321-9.228c8.105,0,14.34,2.743,18.829,8.479V22.181l19.702-4.082V110.841z M0,128h128V0H0V128z"
                    fill={color}
                    fillRule="evenodd"
                />
            </g>
        </svg>
    );
};

export default DailyMotion;
